import { Box, Stack, Typography, Avatar, Chip, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import type { DevWorkLoad } from "../../store/slice/bug-fix/types";

type DeveloperWorkloadProps = {
  developers?: DevWorkLoad[];
};

const DeveloperWorkload = ({ developers = [] }: DeveloperWorkloadProps) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        backgroundColor: colors.primary[900],
        borderRadius: "16px",
        p: 2,
        border: "1px solid rgba(226, 232, 240, 1)",
      }}
    >
      {/* Header */}
      <Stack direction="row" alignItems="center" spacing={1} mb={2}>
        <PersonOutlineIcon sx={{ color: "rgba(100, 116, 139, 1)" }} />
        <Typography fontWeight={600}>
          Developer workload
        </Typography>
      </Stack>

      {/* Developers */}
      <Stack direction="row" spacing={2}>
        {developers.length === 0 ? (
          <Box
            sx={{
              flex: 1,
              borderRadius: "14px",
              p: 2,
              textAlign: "center",
              border: "1px solid rgba(226, 232, 240, 1)",
              backgroundColor: colors.primary[900],
            }}
          >
            <Typography variant="body2" color="text.secondary">
              No developer workload data.
            </Typography>
          </Box>
        ) : (
          developers.map((dev) => (
            <Box
              key={`${dev.assigned_to}-${dev.username}`}
              sx={{
                flex: 1,
                borderRadius: "14px",
                p: 1.5,
                textAlign: "center",
                border: "1px solid rgba(226, 232, 240, 1)",
                backgroundColor: colors.primary[900],
                maxWidth: "300px"
              }}
            >
              <Avatar
                sx={{
                  width: 40,
                  height: 40,
                  mx: "auto",
                  mb: 1,
                }}
                src={
                  dev.profile_picture
                    ? dev.profile_picture.replace(
                      "http://localhost:8000",
                      "https://j8s6hw8d-8000.uks1.devtunnels.ms"
                    )
                    : undefined
                }

              >
                {dev.full_name.charAt(0)}
              </Avatar>

              <Typography variant="body2" fontWeight={500}>
                {dev.full_name}
              </Typography>

              <Chip
                size="small"
                label={`${dev.assignments} Assignment${dev.assignments > 1 ? "s" : ""
                  }`}
                sx={{
                  mt: 1,
                  backgroundColor: "rgba(219, 234, 254, 1)",
                  color: "rgba(37, 99, 235, 1)",
                  fontWeight: 500,
                }}
              />
            </Box>
          ))
        )}
      </Stack>
    </Box>
  );
};

export default DeveloperWorkload;
